import {useCallback, useContext} from "react";
import GlobalContext             from "@components/contexts/GlobalContext";
import lookups                   from "@tools/lookups.json";
import pageList                  from "@tools/page_list";

const  useUserRights = () => {
    const {state} = useContext(GlobalContext);
    const {user, userCompanies} = state;

    const checkGridMenuItems = useCallback((branch, right, item) => {
        if(item?.denyUpdate && right === lookups.obj.securityGroup.action.update)
            return false
        if(item?.denyRemove && right === lookups.obj.securityGroup.action.remove)
            return false

        const defaultRights = user.role.defaultRights

        const currentRights = user.role.rights?.find(it => it.entity === branch)

        if (!currentRights) {
            if (defaultRights === lookups.obj.securityGroup.defaultRights.all)
                return true
            return defaultRights === right
        }
        else if (currentRights.permissions.some(it => it.action === lookups.obj.securityGroup.action.denied)) {
            return false
        }
        else if (currentRights.permissions.some(it => it.action === lookups.obj.securityGroup.action.all)) {
            return true
        }
        else if (currentRights.permissions.some(it => it.action === right && !it.owner)) {
            return true
        }
        else if (currentRights.permissions.some(it => it.action === right && it.owner) && (!item.tid || item.tid?.includes(user._id))) {
            return true
        }
        else if (currentRights.permissions.length && right === "read") {
            return true
        }

        return false
    }, [user]);

    const checkVisiblePages = useCallback(() => {
        const defaultRights = user.role.defaultRights;

        const result = pageList.reduce((res, page) => {
            const currentRights = user.role.rights?.find(it => it.entity === page.id)

            if (!currentRights) {
                if (defaultRights !== lookups.obj.securityGroup.defaultRights.denied)
                    res.push(page)
            }
            else if (currentRights.permissions.every(it => it.action !== lookups.obj.securityGroup.action.denied)){
                res.push(page)
            }

            return res
        }, [])

        return result
    }, [user]);

    const canRenderLink = useCallback((linkName, companyId) => {
        let visiblePages = checkVisiblePages();

        const hasOwnCompany = !companyId || userCompanies.some(company => company._id === companyId);
        return !user.group || user.role._id === "groupAdmin" || (hasOwnCompany && visiblePages?.some(page => page.id === linkName))
    }, [user, userCompanies, checkVisiblePages]);

    return {checkGridMenuItems, checkVisiblePages, canRenderLink}
};

export default useUserRights
